/**
 * Action reference for updating user profile information
 */
export const UPDATE_PROFILE_ACTION_REFERENCE = 'Update';
